import { useMemo } from "react";

import { Milestone } from "../types/service.type";
import { ContractState } from "../types/contractState.types";
import {
  canRequesterReleasePayment,
  canProviderSendReminder,
  shouldShowMilestoneStatus,
  getMilestoneActionType,
  MilestoneActionType,
} from "../utils/milestoneActionLogic";

/**
 * Hook that determines available actions and visibility for a milestone.
 * Returns all relevant flags for rendering milestone UI.
 */
export const useMilestoneActions = (
  milestone: Milestone,
  contractState: ContractState,
  isProvider: boolean,
  isOwnershipLoading: boolean
) => {
  return useMemo(() => {
    const canRelease = canRequesterReleasePayment(
      milestone,
      contractState.contractStatus,
      isProvider,
      isOwnershipLoading
    );

    const canRemind = canProviderSendReminder(milestone, contractState, isProvider, isOwnershipLoading);

    const showStatus = shouldShowMilestoneStatus(milestone, contractState, isProvider);

    const actionType: MilestoneActionType = getMilestoneActionType(
      milestone,
      contractState,
      isProvider,
      isOwnershipLoading
    );

    return {
      canRelease,
      canRemind,
      showStatus,
      actionType,
    };
  }, [
    milestone.id,
    milestone.status,
    contractState.contractStatus,
    contractState.serviceRequestStatus,
    contractState.serviceRequestType,
    contractState.milestones,
    contractState.paymentData?.status,
    isProvider,
    isOwnershipLoading,
  ]);
};
